import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: {
                    nav: {
                        inicio: 'Home',
                        encontro: 'The Meeting',
                        autoridades: 'Authorities',
                        programacao: 'Schedule',
                        dressCode: 'Dress Code',
                        local: 'Location',
                        heraldica: 'Heraldry',
                        galeria: 'Gallery',
                        coordenacao: 'Coordination',
                        brand: 'National Templar Meeting'
                    },
                    support_official: 'OFFICIAL SUPPORT',
                    hero: {
                        eyebrow_main: 'Grand Templar Priory of Brazil · Spiritual Cavalry St. John the Baptist',
                        eyebrow_sub: 'OSMTH Brazil · OSMTH Magnum Magisterium',
                        title_main: 'National Templar Meeting of',
                        title_highlight: 'Squires, Dames and Knights',
                        title_sub: '',
                        subtitle: 'A spiritual journey of reconnecting with our vows and the essence of the Order.',
                        date_label: 'Date',
                        date_value: 'March 19 to 22',
                        year_label: 'Year',
                        location_label: 'Location',
                        location_value: 'Rio de Janeiro — RJ',
                        cta: 'See Schedule'
                    },
                    about: {
                        tag: 'The Purpose of the Meeting',
                        heading: 'The call resurfaces',
                        heading_span: 'through the ages.',
                        msg: 'This meeting brings together Brother Knights and Sister Dames where faith embraces history, strengthening the Templar soul forged in brotherhood.',
                        realization: 'Realization'
                    },
                    authorities: {
                        tag: 'Presences of Honor',
                        title: 'Authorities and',
                        title_span: 'Lidery of the Order',
                        roles: {
                            grao_mestre: 'Grand Master of the Order',
                            grao_prior: 'Magisterial Grand Prior of Brazil\nMagnus Crux',
                            prior_sul: 'Grand Prior of the South / Seneschal\nMagnus Crux',
                            prioresa_mg: 'Prioress of MG and Commandress\nMagnus Officialis',
                            raymond_name: 'Raymond Chomette',
                            raymond_role: 'Magisterial Grand Prior of France\nMagnus Crux',
                            clayton_name: 'Clayton Serrinha Guedes',
                            clayton_role: 'Regent of the Templar Commandery São Miguel Arcanjo - Rio de Janeiro / RJ\nOfficialis'
                        }
                    },
                    program: {
                        tag: 'Official Schedule',
                        title: 'Official',
                        title_span: 'Schedule',
                        thursday: 'Thursday · Opening',
                        friday: 'Friday · Ceremony',
                        saturday: 'Saturday · National Meeting',
                        sunday: 'Sunday · Closing',
                        events: {
                            credenciamento: 'Start of check-in and welcome cocktail',
                            cafe: 'Breakfast',
                            free_time: 'Free morning to explore Rio de Janeiro',
                            almoco: 'Lunch (not included)',
                            traslado: 'Promptly at the hotel door — transfer to the church for the lecture',
                            painel_painelistas: 'Prior do Sul ++ Sideni Moratelli',
                            conventus_templi: 'AT THE CHURCH: CONVENTUS TEMPLI',
                            painel_titulo: '"Historical View of Templar Influence on the Development of Brazil"',
                            
                            mesa_redonda: 'Panel with Grand Master Dom Albino Neves and Grand Magistral Prior of Brazil ++ Fernando Bacellar',
                            organizacao: 'Brief break and formation of the procession into the church',
                            investidura: 'Conventus Templi and Naming Ceremony',
                            coquetel: 'Cocktail included for registered attendees',
                            translado_hotel_dia20: 'Transfer back to the hotel',
                            preparar_cristo: 'Get ready for the trip to Christ the Redeemer',
                            van_cristo: 'Punctually at the hotel entrance — van to Christ the Redeemer',
                            cristo: 'Visit to Christ the Redeemer',
                            descanso: 'rest at the Vila Galé Hotel',
                            conversa: 'Chat with Grand Master Dom Albino Neves and Grand Magistral Prior of Brazil ++ Fernando Bacellar',
                            intervalo: 'Coffee break',
                            encontro_nacional: 'National Templar Meeting',
                            jantar_gala: 'Gala Dinner',
                            beija_flor: '(Beija Flor event room)'
                        }
                    },
                    dress_code: {
                        tag: 'Dress Guide',
                        title: 'Official',
                        title_span: 'Dress Code',
                        occasions: {
                            casual: 'Reception, Registration, Breakfasts, Tours & Words from the Grand Master',
                            formal: 'At the Church (Conventus Templi) & Naming Ceremony',
                            formal_parcial: 'Visit to Christ the Redeemer',
                            gala: 'Gala Dinner'
                        },
                        levels: {
                            casual: 'Casual attire',
                            formal: 'Formal attire',
                            formal_parcial: 'Partial formal attire',
                            gala: 'Gala'
                        },
                        descriptions: {
                            casual: 'Light clothes as the weather is hot: pants, skirt or shorts, shirt or t-shirt, and comfortable shoes (sneakers/sandals).',
                            formal_manto: 'Black suit or set, white shirt, black tie, black shoes and black socks + cloak with Gloves, Jewels and Honors.',
                            formal_parcial_manto: 'Black pants, white shirt, black tie, black shoes and black socks + cloak with gloves, Jewels and honors.',
                            gala: 'Men in suits, Women in dresses or sets.'
                        }
                    },
                    practical: {
                        tag: 'Logistics',
                        title: 'Practical',
                        title_span: 'Information',
                        hotels: 'Recommended Accommodation',
                        logistics_title: 'Logistics',
                        logistics_msg: 'There will be a van and organizational support for the journey to Christ the Redeemer. Seats for certain acts are limited.',
                        location_title: 'Event Location',
                        address_label: 'Address'
                    },
                    heraldry: {
                        tag: 'Heraldry',
                        title: 'Order',
                        title_span: 'Coats of Arms',
                        caption_brasil: 'Coat of Arms of Brazil',
                        sub_brasil: 'Grand Templar Priory of Brazil \nNational Leadership',
                        caption_magistral: 'World Coat of Arms',
                        sub_magistral: 'OSMTH - Magnum Magisterium \nworld leadership',
                        brasao_rj: 'State Coat of Arms of Rio de Janeiro',
                        sub_rj: 'Templar Commandery of St. Michael the Archangel \nRio de Janeiro / RJ'
                    },
                    footer: {
                        contact_label: 'Official Contact',
                        support_text: 'For information and support about the event, talk to our commission — Sidení Morateli.',
                        quote: '"True strength does not lie in the sword, but in the spirit."',
                        rights: 'All rights reserved.',
                        dev_by: 'Developed by',
                        dev_contact: 'Talk to the Developer'
                    },
                    gallery: {
                        tag: 'Event Record',
                        title: 'Photo',
                        title_span: 'Gallery',
                        coming_soon: 'Coming soon',
                        see_all: 'See all photos',
                        back: 'Back',
                        page_title: 'Photo',
                        page_title_span: 'Gallery',
                        page_description: 'Photos from the National Templar Meeting will be published here after the event.'
                    },
                    coordination: {
                        tag: 'Organizing Team',
                        title: 'Coordination of the',
                        title_span: 'National Templar Meeting',
                        role_coordinator: 'General Coordinator'
                    },
                    countdown: {
                        days: 'Days',
                        hours: 'Hours',
                        minutes: 'Minutes',
                        seconds: 'Seconds'
                    }
                }
            },
            pt: {
                translation: {
                    nav: {
                        inicio: 'Início',
                        encontro: 'O Encontro',
                        autoridades: 'Autoridades',
                        programacao: 'Programação',
                        dressCode: 'Dress Code',
                        local: 'Local',
                        heraldica: 'Heráldica',
                        galeria: 'Galeria',
                        coordenacao: 'Coordenação',
                        brand: 'Encontro Nacional Templário'
                    },
                    support_official: 'SUPORTE OFICIAL',
                    hero: {
                        eyebrow_main: 'Gran Priorato Templário do Brasil · Cavalaria Espiritual São João Batista',
                        eyebrow_sub: 'OSMTH Brasil · OSMTH Magnum Magisterium',
                        title_main: 'Encontro Nacional Templário de',
                        title_highlight: 'Escudeiros, Damas e Cavaleiros',
                        title_sub: '',
                        subtitle: 'Uma jornada espiritual de reencontro com nossos votos e a essência da Ordem.',
                        date_label: 'Data',
                        date_value: '19 a 22 de Março',
                        year_label: 'Ano',
                        location_label: 'Local',
                        location_value: 'Rio de Janeiro — RJ',
                        cta: 'Ver Programação'
                    },
                    about: {
                        tag: 'O Propósito do Encontro',
                        heading: 'O chamado ressurge',
                        heading_span: 'através dos tempos.',
                        msg: 'Este encontro reúne Irmãos Cavaleiros e Irmãs Damas onde a fé abraça a história, fortalecendo a alma templária forjada na fraternidade.',
                        realization: 'Realização'
                    },
                    authorities: {
                        tag: 'Presenças de Honra',
                        title: 'Autoridades e',
                        title_span: 'Lideranças da Ordem',
                        roles: {
                            grao_mestre: 'Grão Mestre da Ordem',
                            grao_prior: 'Gran Prior Magistral do Brasil\nMagnus Crux',
                            prior_sul: 'Prior do sul / Senescal\nMagnus Crux',
                            prioresa_mg: 'Prioresa de MG e Comendadora\nMagnus Officialis',
                            raymond_name: 'Raymond Chomette',
                            raymond_role: 'Gran Prior Magistral da França\nMagnus Crux',
                            clayton_name: 'Clayton Serrinha Guedes',
                            clayton_role: 'Regente de Comendadoria Templária São Miguel Arcanjo - Rio de Janeiro / RJ\nOfficialis'
                        }
                    },
                    program: {
                        tag: 'Cronograma Oficial',
                        title: 'Programação',
                        title_span: 'Oficial',
                        thursday: 'Quinta-feira · Abertura',
                        friday: 'Sexta-feira · Cerimônia',
                        saturday: 'Sábado · Encontro Nacional',
                        sunday: 'Domingo · Encerramento',
                        events: {
                            credenciamento: 'Início do credenciamento e coquetel de boas-vindas',
                            cafe: 'Café da manhã',
                            free_time: 'Manhã livre para explorar o Rio de Janeiro',
                            almoco: 'Almoço (não incluso)',
                            traslado: 'Pontualmente na porta do hotel — traslado para a igreja para a palestra',
                            painel_painelistas: 'Prior do Sul ++ Sideni Moratelli',
                            conventus_templi: 'NA IGREJA: CONVENTUS TEMPLI',
                            painel_titulo: '"Visão Histórica da Influência Templária no Desenvolvimento do Brasil"',
                            
                            mesa_redonda: 'Painel com a participação do Grão Mestre Dom Albino Neves e o Gran Prior Magistral do Brasil ++ Fernando Bacellar',
                            organizacao: 'Breve intervalo e formação da procissão de entrada na igreja',
                            investidura: 'Conventus Templi e Cerimônia de Nomeação',
                            coquetel: 'Coquetel incluso para os inscritos do encontro',
                            translado_hotel_dia20: 'Traslado de volta para o hotel',
                            preparar_cristo: 'Se arrumar para a saída para o Cristo Redentor',
                            van_cristo: 'Pontualmente na porta do hotel — van para o Cristo Redentor',
                            cristo: 'Visita ao Cristo Redentor',
                            descanso: 'descanso no Hotel Vila Galé',
                            conversa: 'Conversa (bate papo) com o Grão Mestre Dom Albino Neves e o Gran Prior Magistral do Brasil ++ Fernando Bacellar',
                            intervalo: 'Intervalo para café',
                            encontro_nacional: 'Encontro Nacional Templário',
                            jantar_gala: 'Jantar de Gala',
                            beija_flor: '(sala de eventos Beija Flor)'
                        }
                    },
                    dress_code: {
                        tag: 'Guia de Trajes',
                        title: 'Dress Code',
                        title_span: 'Oficial',
                        occasions: {
                            casual: 'Recepção, Cadastro, Cafés da manhã, Passeios e Palavras do Gran-Mestre',
                            formal: 'Na Igreja (Conventus Templi) e Cerimônia de Nomeação',
                            formal_parcial: 'Visita ao Cristo Redentor',
                            gala: 'Jantar de Gala'
                        },
                        levels: {
                            casual: 'Traje casual',
                            formal: 'Traje formal',
                            formal_parcial: 'Traje formal parcial',
                            gala: 'Gala'
                        },
                        descriptions: {
                            casual: 'Roupas leves pois o clima é quente: calça, saia ou shorts, camiseta/camisa, e calçados confortáveis (tênis/sandálias).',
                            formal_manto: 'Terno ou conjunto preto, camisa branca, gravata preta, sapatos e meia preta + manto com Luvas, Joias e Veneras.',
                            formal_parcial_manto: 'Calça preta, camisa branca, gravata preta, sapatos e meia preta + manto com Luvas, Joias e Veneras.',
                            gala: 'Homens de terno, Mulheres de vestido ou conjuntos.'
                        }
                    },
                    practical: {
                        tag: 'Logística',
                        title: 'Informações',
                        title_span: 'Práticas',
                        hotels: 'Hospedagem Recomendada',
                        logistics_title: 'Logística',
                        logistics_msg: 'Haverá van e apoio organizacional para o trajeto até o Cristo Redentor. Vagas para certos atos são limitadas.',
                        location_title: 'Localização do evento',
                        address_label: 'Endereço'
                    },
                    heraldry: {
                        tag: 'Heráldica',
                        title: 'Brasões',
                        title_span: 'da Ordem',
                        caption_brasil: 'Brasão do Brasil',
                        sub_brasil: 'Gran Priorato Templário do Brasil \nLiderança Nacional',
                        caption_magistral: 'Brasão Mundial',
                        sub_magistral: 'OSMTH - Magnum Magisterium \nLiderança mundial',
                        brasao_rj: 'Brasão Estadual do Rio de janeiro',
                        sub_rj: 'Comendadoria Templária São Miguel Arcanjo \nRio de Janeiro / RJ'
                    },
                    footer: {
                        contact_label: 'Contato Oficial',
                        support_text: 'Para informações e suporte sobre o evento, fale com nossa comissão — Sidení Morateli.',
                        quote: '"A verdadeira força não reside na espada, mas no espírito."',
                        rights: 'Todos os direitos reservados.',
                        dev_by: 'Desenvolvido por',
                        dev_contact: 'Fale com o Desenvolvedor'
                    },
                    gallery: {
                        tag: 'Registro do Evento',
                        title: 'Galeria',
                        title_span: 'de Fotos',
                        coming_soon: 'Em breve',
                        see_all: 'Ver todas as fotos',
                        back: 'Voltar',
                        page_title: 'Galeria',
                        page_title_span: 'de Fotos',
                        page_description: 'As fotos do Encontro Nacional Templário serão publicadas aqui após o evento.'
                    },
                    coordination: {
                        tag: 'Equipe Organizadora',
                        title: 'Coordenação do',
                        title_span: 'Encontro Nacional Templário',
                        role_coordinator: 'Coordenador Geral'
                    },
                    countdown: {
                        days: 'Dias',
                        hours: 'Horas',
                        minutes: 'Minutos',
                        seconds: 'Segundos'
                    }
                }
            },
            fr: {
                translation: {
                    nav: {
                        inicio: 'Accueil',
                        encontro: 'La Rencontre',
                        autoridades: 'Autorités',
                        programacao: 'Programme',
                        dressCode: 'Code Vestimentaire',
                        local: 'Emplacement',
                        heraldica: 'Héraldique',
                        galeria: 'Galerie',
                        coordenacao: 'Coordination',
                        brand: 'Rencontre Nationale Templière'
                    },
                    support_official: 'SOUTIEN OFFICIEL',
                    hero: {
                        eyebrow_main: 'Grand Prieuré Templier du Brésil · Cavalerie Spirituelle Saint Jean-Baptiste',
                        eyebrow_sub: 'OSMTH Brésil · OSMTH Magnum Magisterium',
                        title_main: 'Rencontre Nationale Templière de',
                        title_highlight: 'Écuyers, Dames et Chevaliers',
                        title_sub: '',
                        subtitle: 'Un voyage spirituel de reconnexion avec nos vœux et l\'essence de l\'Ordre.',
                        date_label: 'Date',
                        date_value: '19 au 22 Mars',
                        year_label: 'Année',
                        location_label: 'Lieu',
                        location_value: 'Rio de Janeiro — RJ',
                        cta: 'Voir le Programme'
                    },
                    about: {
                        tag: 'Le But de la Rencontre',
                        heading: 'L\'appel resurgit',
                        heading_span: 'à travers les âges.',
                        msg: 'Cette rencontre réunit Frères Chevaliers et Sœurs Dames où la foi embrasse l\'histoire, renforçant l\'âme templière forgée dans la fraternité.',
                        realization: 'Réalisation'
                    },
                    authorities: {
                        tag: 'Présences d\'Honneur',
                        title: 'Autorités et',
                        title_span: 'Dirigeants de l\'Ordre',
                        roles: {
                            grao_mestre: 'Grand Maître de l\'Ordre',
                            grao_prior: 'Grand Prieur Magistral du Brésil\nMagnus Crux',
                            prior_sul: 'Prieur du Sud / Sénéchal\nMagnus Crux',
                            prioresa_mg: 'Prieure de MG et Commandeure\nMagnus Officialis',
                            raymond_name: 'Raymond Chomette',
                            raymond_role: 'Grand Prieur Magistral de France\nMagnus Crux',
                            clayton_name: 'Clayton Serrinha Guedes',
                            clayton_role: 'Régent de la Commanderie Templière São Miguel Arcanjo - Rio de Janeiro / RJ\nOfficialis'
                        }
                    },
                    program: {
                        tag: 'Calendrier Officiel',
                        title: 'Programme',
                        title_span: 'Officiel',
                        thursday: 'Jeudi · Ouverture',
                        friday: 'Vendredi · Cérémonie',
                        saturday: 'Samedi · Rencontre Nationale',
                        sunday: 'Dimanche · Clôture',
                        events: {
                            credenciamento: 'Début de l\'enregistrement et cocktail de bienvenue',
                            cafe: 'Petit déjeuner',
                            free_time: 'Matinée libre pour explorer Rio de Janeiro',
                            almoco: 'Déjeuner (non inclus)',
                            traslado: 'Ponctuellement à la porte de l\'hôtel — transfert à l\'église pour la conférence',
                            painel_painelistas: 'Prior do Sul ++ Sideni Moratelli',
                            conventus_templi: 'À L\'ÉGLISE : CONVENTUS TEMPLI',
                            painel_titulo: '"Vision historique de l\'influence templière sur le développement du Brésil"',
                            
                            mesa_redonda: 'Panel avec le Grand Maître Dom Albino Neves et le Grand Prieur Magistral du Brésil ++ Fernando Bacellar',
                            organizacao: 'Brève pause et formation de la procession d\'entrée dans l\'église',
                            investidura: 'Conventus Templi et Cérémonie de Nomination',
                            coquetel: 'Cocktail inclus pour les inscrits à la rencontre',
                            translado_hotel_dia20: 'Transfert de retour à l\'hôtel',
                            preparar_cristo: 'Se préparer pour la sortie au Christ Rédempteur',
                            van_cristo: 'Ponctuellement à l\'entrée de l\'hôtel — van vers le Christ Rédempteur',
                            cristo: 'Visite au Christ Rédempteur',
                            descanso: 'repos à l\'Hôtel Vila Galé',
                            conversa: 'Discussion avec le Grand Maître Dom Albino Neves et le Grand Prieur Magistral du Brésil ++ Fernando Bacellar',
                            intervalo: 'Pause café',
                            encontro_nacional: 'Rencontre Nationale Templière',
                            jantar_gala: 'Dîner de Gala',
                            beija_flor: '(salle d\'événements Beija Flor)'
                        }
                    },
                    dress_code: {
                        tag: 'Guide Vestimentaire',
                        title: 'Code',
                        title_span: 'Vestimentaire Officiel',
                        occasions: {
                            casual: 'Réception, Enregistrement, Petit-déjeuners, Visites et Paroles du Grand Maître',
                            formal: 'À l\'église (Conventus Templi) et Cérémonie de Nomination',
                            formal_parcial: 'Visite au Christ Rédempteur',
                            gala: 'Dîner de Gala'
                        },
                        levels: {
                            casual: 'Tenue décontractée',
                            formal: 'Tenue formelle',
                            formal_parcial: 'Tenue formelle partielle',
                            gala: 'Gala'
                        },
                        descriptions: {
                            casual: 'Vêtements légers en raison du climat chaud : pantalon, jupe ou short, chemise ou t-shirt, et chaussures confortables (baskets/sandales).',
                            formal_manto: 'Costume ou ensemble noir, chemise blanche, cravate noire, chaussures et chaussettes noires + manteau avec Gants, Bijoux et Décorations.',
                            formal_parcial_manto: 'Pantalon noir, chemise blanche, cravate noire, chaussures et chaussettes noires + manteau avec gants, Bijoux et décorations.',
                            gala: 'Hommes en costume, Femmes en robes ou ensembles.'
                        }
                    },
                    practical: {
                        tag: 'Logistique',
                        title: 'Informations',
                        title_span: 'Pratiques',
                        hotels: 'Hébergement Recommandé',
                        logistics_title: 'Logistique',
                        logistics_msg: 'Il y aura un van et un soutien organisationnel pour le voyage vers le Christ Rédempteur. Les places pour certains actes sont limitées.',
                        location_title: 'Lieu de l\'événement',
                        address_label: 'Adresse'
                    },
                    heraldry: {
                        tag: 'Héraldique',
                        title: 'Blasons',
                        title_span: 'de l\'Ordre',
                        caption_brasil: 'Blason du Brésil',
                        sub_brasil: 'Grand Prieuré Templier',
                        caption_magistral: 'Blason Mondial',
                        sub_magistral: 'osmth magnum magisterium\nleadership mondial',
                        brasao_rj: 'Blason de l\'État de Rio de Janeiro',
                        sub_rj: 'Commanderie Templière Saint Michel Archange - Rio de Janeiro / RJ'
                    },
                    footer: {
                        contact_label: 'Contact Officiel',
                        support_text: 'Pour plus d\'informations et de soutien sur l\'événement, contactez notre commission — Sidení Morateli.',
                        quote: '"La vraie force ne réside pas dans l\'épée, mais dans l\'esprit."',
                        rights: 'Tous droits réservés.',
                        dev_by: 'Développé par',
                        dev_contact: 'Contacter le Développeur'
                    },
                    gallery: {
                        tag: 'Registre de l\'Événement',
                        title: 'Galerie',
                        title_span: 'de Photos',
                        coming_soon: 'Bientôt',
                        see_all: 'Voir toutes les photos',
                        back: 'Retour',
                        page_title: 'Galerie',
                        page_title_span: 'de Photos',
                        page_description: 'Les photos de la Rencontre Nationale Templière seront publiées ici après l\'événement.'
                    },
                    coordination: {
                        tag: 'Équipe Organisatrice',
                        title: 'Coordination de la',
                        title_span: 'Rencontre Nationale Templière',
                        role_coordinator: 'Coordinateur Général'
                    },
                    countdown: {
                        days: 'Jours',
                        hours: 'Heures',
                        minutes: 'Minutes',
                        seconds: 'Secondes'
                    }
                }
            },
            es: {
                translation: {
                    nav: {
                        inicio: 'Inicio',
                        encontro: 'El Encuentro',
                        autoridades: 'Autoridades',
                        programacao: 'Programa',
                        dressCode: 'Código de Vestimenta',
                        local: 'Ubicación',
                        heraldica: 'Heráldica',
                        galeria: 'Galería',
                        coordenacao: 'Coordinación',
                        brand: 'Encuentro Nacional Templario'
                    },
                    support_official: 'SOPORTE OFICIAL',
                    hero: {
                        eyebrow_main: 'Gran Priorato Templario de Brasil · Caballería Espiritual San Juan Bautista',
                        eyebrow_sub: 'OSMTH Brasil · OSMTH Magnum Magisterium',
                        title_main: 'Encuentro Nacional Templario de',
                        title_highlight: 'Escuderos, Damas y Caballeros',
                        title_sub: '',
                        subtitle: 'Un viaje espiritual de reencuentro con nuestros votos y la esencia de la Orden.',
                        date_label: 'Fecha',
                        date_value: '19 al 22 de Marzo',
                        year_label: 'Año',
                        location_label: 'Lugar',
                        location_value: 'Río de Janeiro — RJ',
                        cta: 'Ver Programa'
                    },
                    about: {
                        tag: 'El Propósito del Encuentro',
                        heading: 'El llamado resurge',
                        heading_span: 'a través de los tiempos.',
                        msg: 'Este encuentro reúne Escuderos, Hermanos Caballeros y Hermanas Damas donde la fe abraza la historia, fortaleciendo el alma templaria forjada en la fraternidad.',
                        realization: 'Realización'
                    },
                    authorities: {
                        tag: 'Presencias de Honor',
                        title: 'Autoridades y',
                        title_span: 'Liderazgo de la Orden',
                        roles: {
                            grao_mestre: 'Gran Maestre de la Orden',
                            grao_prior: 'Gran Prior Magistral de Brasil\nMagnus Crux',
                            prior_sul: 'Prior del Sur / Senescal\nMagnus Crux',
                            prioresa_mg: 'Priora de MG y Comendadora\nMagnus Officialis',
                            clayton_name: 'Clayton Serrinha Guedes',
                            clayton_role: 'Regente de Encomienda Templaria São Miguel Arcanjo - Río de Janeiro / RJ\nOfficialis'
                        }
                    },
                    program: {
                        tag: 'Cronograma Oficial',
                        title: 'Programa',
                        title_span: 'Oficial',
                        thursday: 'Jueves · Apertura',
                        friday: 'Viernes · Ceremonia',
                        saturday: 'Sábado · Encuentro Nacional',
                        sunday: 'Domingo · Cierre',
                        events: {
                            credenciamento: 'Inicio de acreditación y cóctel de bienvenida',
                            cafe: 'Desayuno',
                            free_time: 'Mañana libre para explorar Río de Janeiro',
                            almoco: 'Almuerzo (no incluido)',
                            traslado: 'Puntualmente en la puerta del hotel — traslado a la iglesia para la conferencia',
                            painel_painelistas: 'Prior do Sul ++ Sideni Moratelli',
                            conventus_templi: 'EN LA IGLESIA: CONVENTUS TEMPLI',
                            painel_titulo: '"Visión Histórica de la Influencia Templaria en el Desarrollo de Brasil"',
                            
                            mesa_redonda: 'Panel con Gran Maestre Dom Albino Neves y el Gran Prior Magistral de Brasil ++ Fernando Bacellar',
                            organizacao: 'Breve intervalo y formación de la procesión de entrada en la iglesia',
                            investidura: 'Conventus Templi y Ceremonia de Nombramiento',
                            coquetel: 'Cóctel incluido para los inscritos del encuentro',
                            translado_hotel_dia20: 'Traslado de vuelta al hotel',
                            preparar_cristo: 'Prepararse para la salida al Cristo Redentor',
                            van_cristo: 'Puntualmente en la puerta del hotel — van al Cristo Redentor',
                            cristo: 'Visita al Cristo Redentor',
                            descanso: 'descanso en el Hotel Vila Galé',
                            conversa: 'Charla con el Gran Maestre Dom Albino Neves y el Gran Prior Magistral de Brasil ++ Fernando Bacellar',
                            intervalo: 'Pausa para café',
                            encontro_nacional: 'Encuentro Nacional Templario',
                            jantar_gala: 'Cena de Gala',
                            beija_flor: '(salón de eventos Beija Flor)'
                        }
                    },
                    dress_code: {
                        tag: 'Guía de Vestimenta',
                        title: 'Código de',
                        title_span: 'Vestimenta Oficial',
                        occasions: {
                            casual: 'Recepción, Registro, Desayunos, Paseos y Palabras del Gran Maestre',
                            formal: 'En la Iglesia (Conventus Templi) y Ceremonia de Nombramiento',
                            formal_parcial: 'Visita al Cristo Redentor',
                            gala: 'Cena de Gala'
                        },
                        levels: {
                            casual: 'Vestimenta casual',
                            formal: 'Vestimenta formal',
                            formal_parcial: 'Vestimenta formal parcial',
                            gala: 'Gala'
                        },
                        descriptions: {
                            casual: 'Ropa ligera ya que el clima es caluroso: pantalón, falda o shorts, camisa o camiseta, y calzado cómodo (tenis/sandalias).',
                            formal_manto: 'Traje o conjunto negro, camisa blanca, corbata negra, zapatos y calcetines negros + manto con Guantes, Joyas y Condecoraciones.',
                            formal_parcial_manto: 'Pantalón negro, camisa blanca, corbata negra, zapatos y calcetines negros + manto con guantes, Joyas y condecoraciones.',
                            gala: 'Hombres de traje, Mujeres de vestido o conjuntos.'
                        }
                    },
                    practical: {
                        tag: 'Logística',
                        title: 'Información',
                        title_span: 'Práctica',
                        hotels: 'Alojamiento Recomendado',
                        logistics_title: 'Logística',
                        logistics_msg: 'Habrá una van y apoyo organizacional para el trayecto al Cristo Redentor. Los lugares para ciertos actos son limitados.',
                        location_title: 'Ubicación del evento',
                        address_label: 'Dirección'
                    },
                    heraldry: {
                        tag: 'Heráldica',
                        title: 'Escudos',
                        title_span: 'de la Orden',
                        caption_brasil: 'Escudo de Brasil',
                        sub_brasil: 'Gran Priorato Templario de Brasil\nLiderazgo Nacional',
                        caption_magistral: 'Escudo Mundial',
                        sub_magistral: 'OSMTH - Magnum Magisterium\nLiderazgo mundial',
                        brasao_rj: 'Escudo del Estado de Río de Janeiro',
                        sub_rj: 'Encomienda Templaria San Miguel Arcángel\nRío de Janeiro / RJ'
                    },
                    footer: {
                        contact_label: 'Contacto Oficial',
                        support_text: 'Para información y soporte sobre el evento, hable con nuestra comisión — Sidení Morateli.',
                        quote: '"La verdadera fuerza no reside en la espada, sino en el espíritu."',
                        rights: 'Todos los derechos reservados.',
                        dev_by: 'Desarrollado por',
                        dev_contact: 'Hablar con el Desarrollador'
                    },
                    gallery: {
                        tag: 'Registro del Evento',
                        title: 'Galería',
                        title_span: 'de Fotos',
                        coming_soon: 'Próximamente',
                        see_all: 'Ver todas las fotos',
                        back: 'Volver',
                        page_title: 'Galería',
                        page_title_span: 'de Fotos',
                        page_description: 'Las fotos del Encuentro Nacional Templario serán publicadas aquí después del evento.'
                    },
                    coordination: {
                        tag: 'Equipo Organizador',
                        title: 'Coordinación del',
                        title_span: 'Encuentro Nacional Templario',
                        role_coordinator: 'Coordinador General'
                    },
                    countdown: {
                        days: 'Días',
                        hours: 'Horas',
                        minutes: 'Minutos',
                        seconds: 'Segundos'
                    }
                }
            }
        },
        fallbackLng: 'pt',
        interpolation: {
            escapeValue: false,
        }
    });

export default i18n;
